/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_SubmittingInputs */

const en_us2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pt_br2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const es_419_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const pt_pt2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A enviar…`)
};

const fr_fr2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const de_de2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

const it_it2_auth_email_submitting = /** @type {(inputs: Auth_Email_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Auth_Email_SubmittingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_submitting = /** @type {((inputs?: Auth_Email_SubmittingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_SubmittingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_submitting(inputs)
	if (locale === "es-419") return es_419_auth_email_submitting(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_submitting(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_submitting(inputs)
	if (locale === "de-DE") return de_de2_auth_email_submitting(inputs)
	if (locale === "it-IT") return it_it2_auth_email_submitting(inputs)
	return en_us2_auth_email_submitting(inputs)
});
export { auth_email_submitting as "auth.email_submitting" }